import { useMemo } from 'react';
import { loggerService } from 'js/services/logger.service';

export const useReduxPublicAPI = () => {

    return useMemo(() => ({
        /**
         * Enable redux logger.
         * @memberOf Playtech.API.redux
         * @function
         */
        enableLogger: loggerService.enableReduxLogger
    }), []);
};
